import React from 'react';
import { Input, Button, message } from 'antd';
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { compose } from 'redux';
import ReactQuill from 'react-quill';
import { translate } from 'react-i18next';
import 'react-quill/dist/quill.snow.css';


class SchoolSettings extends React.Component {

  state = { skillDescription: "none"}

  saveSkillDescription = () => {
    let schoolId = this.props.profile.profile.school.id
    let skillDescription = this.state.skillDescription
    this.props.firebase.database().ref(`/schools/${schoolId}/`).update({
      skill_description: skillDescription})
    message.success('Skills description saved');
  }

  render() {
    const { t } = this.props
    let skill_description = ""
    if (this.props.skill_description) {
      skill_description = this.props.skill_description
    }

    return (
      <div style={styles.container}>
        <h1 style={{fontWight: 'bold'}}>{t('School Admin Settings')}</h1>
        <h2>Skill levels description</h2>
        <ReactQuill value={this.state.skillDescription == 'none' ? skill_description : this.state.skillDescription}
                  onChange={(value) => this.setState({skillDescription: value})}
        />
        <br />
        <Button onClick={() => this.saveSkillDescription()} type="primary">{t('Save')}</Button>
      </div>
    )
  }
}

const enhancer = compose(
  translate('lang'),
  firebaseConnect((props) => {
    return [
      'profile', 'schools'
    ]
  }),
  connect(
    state => {
      const schoolId = state.firebase.profile.profile.school.id

      return {
        profile: state.firebase.profile,
        skill_description: state.firebase.data.schools && state.firebase.data.schools[schoolId].skill_description
      }
    }
  )
)
export default enhancer(SchoolSettings);

const styles = {
  error: {
    fontSize: '14px',
    color: 'red'
  },
  container: {
    margin: 20,
    padding: 40,
    backgroundColor: 'white'
  },
  input: {
    width: 300,
    marginBottom: 20
  },
  textarea: {
    width: 550,
    marginBottom: 20,
    height: 200
  }
}



// WEBPACK FOOTER //
// ./src/containers/SchoolSettings/index.jsx